import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';

import { useHoldingClassListPage } from '../context/HoldingClassListPageContext';

const HoldingClassTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = useHoldingClassListPage();

  const hasOptions = data.isAdmin && !data.isReadOnly;

  const columns = [
    { key: 'class', content: t('Class') },

    { key: 'nominal', content: t('NominalValue'), textPosition: 'right' },

    { key: 'sharesNumber', content: t('SharesNumber'), textPosition: 'right' },

    {
      key: 'numerationOfShares',
      content: t('NumerationOfShares'),
      textPosition: 'right',
      hideOnMobile: true,
    },

    {
      key: 'votesForParticipation',
      content: t('VotesForParticipation'),
      textPosition: 'right',
      hideOnMobile: true,
    },

    {
      key: 'numeration',
      content: t('Numeration'),
      hideOnMobile: true,
    },

    {
      key: 'preferredLiquidation',
      content: t('PreferredLiquidation'),
      hideOnMobile: true,
    },

    {
      key: 'antidilution',
      content: t('Antidilution'),
      hideOnMobile: true,
    },

    hasOptions ? { key: 'actions', content: '', textPosition: 'left' } : null,
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default HoldingClassTableHeader;
